import type { RouteRecordRaw } from 'vue-router'

export const baronRoutes: RouteRecordRaw[] = [
  {
    path: '/baron',
    component: () => import('@/layouts/AppLayout.vue'),
    meta: {
      requiresAuth: true,
      module: 'baron',
      moduleDisplayName: 'Baron',
    },
    children: [
      {
        path: '',
        name: 'baron-sessions',
        component: () => import('@/modules/baron/views/SessionsView.vue'),
      },
      {
        path: 'new',
        name: 'baron-wizard',
        component: () => import('@/modules/baron/views/WizardView.vue'),
      },
      {
        path: ':sessionId/plan',
        name: 'baron-plan',
        component: () => import('@/modules/baron/views/PlanningView.vue'),
        props: true,
      },
      {
        path: ':sessionId/board',
        name: 'baron-board',
        component: () => import('@/modules/baron/views/ControlBoardView.vue'),
        props: true,
      },
      {
        path: ':sessionId/lead',
        name: 'baron-lead',
        component: () => import('@/modules/baron/views/LeaderBoardView.vue'),
        props: true,
      },
    ],
  },
]
